import React, { useState } from "react";
import { FileCheck, ShieldCheck, CreditCard, Loader2 } from "lucide-react";
import { CONTACT } from "../mock";
import api from "../lib/api";
import CurrencySelect from "./CurrencySelect";
import PayPalCheckout from "./PayPalCheckout";

const FmcsaFiling = () => {
  const [form, setForm] = useState({
    name: "",
    business: "",
    email: "",
    phone: "",
    filingType: "New MC Authority",
    businessType: "Motor Carrier",
    trucks: "",
    state: "",
    notes: "",
  });
  const [success, setSuccess] = useState(false);
  const [paying, setPaying] = useState(false);
  const [curCode, setCurCode] = useState("USD");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Persist the application to the backend (best-effort)
    api.post("/fmcsa-applications", form).catch(() => {});
    const subject = encodeURIComponent(`FMCSA Filing Request (${form.filingType}) from ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\n` +
      `Business / Legal Name: ${form.business}\n` +
      `Email: ${form.email}\n` +
      `Phone: ${form.phone}\n` +
      `Filing Type: ${form.filingType}\n` +
      `Business Type: ${form.businessType}\n` +
      `Number of Trucks: ${form.trucks}\n` +
      `State: ${form.state}\n\n` +
      `Notes:\n${form.notes}`
    );
    window.location.href = `mailto:${CONTACT.email}?subject=${subject}&body=${body}`;
    setSuccess(true);
  };

  const payNow = async () => {
    setPaying(true);
    // Save application first so we have the lead even before payment
    api.post("/fmcsa-applications", form).catch(() => {});
    try {
      const r = await api.post("/payments/checkout", {
        package_id: "fmcsa_filing",
        origin_url: window.location.origin,
        email: form.email,
        name: form.name,
        currency: curCode.toLowerCase(),
      });
      window.location.href = r.data.checkout_url;
    } catch (err) {
      setPaying(false);
      alert("Could not start checkout. Please try again or call dispatch.");
    }
  };

  return (
    <section className="fmcsa" id="fmcsa">
      <div className="container">
        <div className="section-head">
          <span className="kicker">Get Authorized</span>
          <h2>Apply for your DOT or MC number</h2>
          <p>New to trucking or starting your own authority? We'll help you file with the FMCSA for your USDOT and MC number. Fill out the form below and we'll walk you through the process.</p>
        </div>

        <div className="fmcsa-grid">
          <div className="fmcsa-info">
            <div className="fmcsa-point">
              <span className="fmcsa-icon"><FileCheck strokeWidth={2} /></span>
              <div>
                <h4>Guided FMCSA Filing</h4>
                <p>USDOT number, MC (operating) authority, or both &mdash; we handle the paperwork and guide you step by step.</p>
              </div>
            </div>
            <div className="fmcsa-point">
              <span className="fmcsa-icon"><ShieldCheck strokeWidth={2} /></span>
              <div>
                <h4>Carrier, Broker &amp; Forwarder</h4>
                <p>Whether you're a motor carrier, a broker, or a freight forwarder, we'll file the correct authority for your operation.</p>
              </div>
            </div>
          </div>

          <form className="contact-form fmcsa-form" onSubmit={handleSubmit}>
            <div className={`form-success ${success ? "show" : ""}`}>Your email app should now be open with your filing request ready to send.</div>
            <div className="form-row">
              <div className="field">
                <label htmlFor="ff-name">Full Name</label>
                <input type="text" id="ff-name" name="name" required placeholder="Jane Trucker" value={form.name} onChange={handleChange} />
              </div>
              <div className="field">
                <label htmlFor="ff-business">Business / Legal Name</label>
                <input type="text" id="ff-business" name="business" placeholder="Your Trucking LLC" value={form.business} onChange={handleChange} />
              </div>
            </div>
            <div className="form-row">
              <div className="field">
                <label htmlFor="ff-email">Email</label>
                <input type="email" id="ff-email" name="email" required placeholder="you@email.com" value={form.email} onChange={handleChange} />
              </div>
              <div className="field">
                <label htmlFor="ff-phone">Phone</label>
                <input type="tel" id="ff-phone" name="phone" required placeholder="(555) 555-5555" value={form.phone} onChange={handleChange} />
              </div>
            </div>
            <div className="form-row">
              <div className="field">
                <label htmlFor="ff-filing">Filing Type</label>
                <select id="ff-filing" name="filingType" value={form.filingType} onChange={handleChange}>
                  <option>New MC Authority</option>
                  <option>New USDOT Number</option>
                  <option>Both DOT &amp; MC</option>
                  <option>Not sure — need guidance</option>
                </select>
              </div>
              <div className="field">
                <label htmlFor="ff-btype">Business Type</label>
                <select id="ff-btype" name="businessType" value={form.businessType} onChange={handleChange}>
                  <option>Motor Carrier</option>
                  <option>Broker</option>
                  <option>Freight Forwarder</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="field">
                <label htmlFor="ff-trucks">Number of Trucks</label>
                <input type="number" id="ff-trucks" name="trucks" min="0" placeholder="1" value={form.trucks} onChange={handleChange} />
              </div>
              <div className="field">
                <label htmlFor="ff-state">State</label>
                <input type="text" id="ff-state" name="state" placeholder="e.g. IL" value={form.state} onChange={handleChange} />
              </div>
            </div>
            <div className="form-row">
              <div className="field full">
                <label htmlFor="ff-notes">Additional Details</label>
                <textarea id="ff-notes" name="notes" placeholder="Tell us your state, current status, and any questions about the FMCSA process..." value={form.notes} onChange={handleChange}></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-block">Submit Filing Request</button>
            <div className="fmcsa-pay">
              <div className="fmcsa-pay-info">
                <span className="fmcsa-price">$150</span>
                <span className="fmcsa-price-label">flat-rate FMCSA filing fee</span>
              </div>
              <div className="fmcsa-pay-actions">
                <div className="fmcsa-cur">Pay in: <CurrencySelect value={curCode} onChange={setCurCode} testid="fmcsa-currency" /></div>
                <button type="button" className="btn btn-pay" onClick={payNow} disabled={paying}>
                  {paying ? <Loader2 size={16} className="spin" /> : <CreditCard size={16} />} Pay &amp; File ($150)
                </button>
                <PayPalCheckout packageId="fmcsa_filing" currency={curCode} email={form.email} name={form.name} />
              </div>
            </div>
            <p className="form-note">Submitting emails your details to {CONTACT.email}. Or pay the flat $250 filing fee securely by card to get started right away.</p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default FmcsaFiling;
